import { Link } from "react-router-dom";
import { XCircle, Home as HomeIcon } from "lucide-react";

export default function BookingCancel() {
  return (
    <div className="min-h-screen bg-[#FDFBF7] grid place-items-center px-4 py-10">
      <div className="comic-card-static p-8 max-w-xl w-full text-center">
        <div className="inline-flex w-14 h-14 rounded-full bg-[#FF3D00] text-white border-[3px] border-[#0B132B] items-center justify-center mb-4 shadow-[4px_4px_0_#0B132B]">
          <XCircle className="w-7 h-7" />
        </div>
        <h1 className="font-['Bebas_Neue'] text-4xl">Payment Cancelled</h1>
        <p className="mt-2 text-[#0B132B]/80">
          No charge was made. Your appointment slot is being held briefly —
          start a new booking to confirm it, or call Dan at 860-250-5755.
        </p>
        <Link to="/" className="mt-6 inline-flex comic-btn comic-btn-primary">
          <HomeIcon className="w-5 h-5" /> Back to booking
        </Link>
      </div>
    </div>
  );
}
